import { DateRangeSelection } from 'src/models/common';

// Nur ein Fetch mit konkretem Datum darf den Datumsfilter eines Listen-Stores überschreiben.
// Nachlade- und Retry-Batches (GenericActivityList.vue: requestNextBatch/retryTheListFetch) senden
// desiredDate: '' und MÜSSEN die Query von Seite 1 unverändert fortsetzen - sonst ginge Seite ≥ 2 mit
// DesktopModuleToolbarDatefieldDateFilter: [""] an den Server (getDatesAsString('') liefert ['']).
// Gleiche Regel wie der Warmup-Dispatcher in src/stores/app/eventSubscriptions/index.ts.
export const isExplicitDesiredDate = (desiredDate: DateRangeSelection | string | undefined): boolean => {
	if (typeof desiredDate === 'string') {
		return desiredDate !== '';
	}

	return desiredDate !== undefined && desiredDate.from !== '';
};
